/**
 * @generated SignedSource<<e0f221a45ff2207767e277eccfbc5c10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type surveysQuery$variables = {
  surveyEntityId: string;
};
export type surveysQueryVariables = surveysQuery$variables;
export type surveysQuery$data = {
  readonly viewer: {
    readonly findSurvey: {
      readonly id: string;
      readonly entityId: string;
      readonly name: string;
      readonly details: string | null;
      readonly questions: ReadonlyArray<{
        readonly surveyQuestion: {
          readonly id: string;
        } | null;
        readonly id: string;
        readonly question: {
          readonly __typename: string;
          readonly body: string;
          readonly hasComment: boolean;
          readonly currentRevision: {
            readonly id: string;
          } | null;
          readonly questionOptionSet?: {
            readonly options: ReadonlyArray<{
              readonly id: string;
              readonly entityId: string;
              readonly body: string;
            }>;
          };
        };
        readonly response: {
          readonly response: any | null;
          readonly multipleChoiceResponse: {
            readonly id: string;
            readonly entityId: string;
            readonly body: string;
          } | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};
export type surveysQueryResponse = surveysQuery$data;
export type surveysQuery = {
  variables: surveysQueryVariables;
  response: surveysQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "surveyEntityId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "surveyId",
    "variableName": "surveyEntityId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "details",
  "storageKey": null
},
v6 = [
  (v2/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "SurveyQuestion",
  "kind": "LinkedField",
  "name": "surveyQuestion",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasComment",
  "storageKey": null
},
v11 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v9/*: any*/)
],
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SurveysQuestionOptionSet",
      "kind": "LinkedField",
      "name": "questionOptionSet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SurveysQuestionOption",
          "kind": "LinkedField",
          "name": "options",
          "plural": true,
          "selections": (v11/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EngagementMultipleChoiceQuestion",
  "abstractKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "response",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "SurveysQuestionOption",
  "kind": "LinkedField",
  "name": "multipleChoiceResponse",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "surveysQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ViewerSurvey",
            "kind": "LinkedField",
            "name": "findSurvey",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SurveyParticipantQuestion",
                "kind": "LinkedField",
                "name": "questions",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "question",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": "currentRevision",
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "currentRevisionV2",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QuestionResponse",
                    "kind": "LinkedField",
                    "name": "response",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "surveysQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ViewerSurvey",
            "kind": "LinkedField",
            "name": "findSurvey",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SurveyParticipantQuestion",
                "kind": "LinkedField",
                "name": "questions",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "question",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": "currentRevision",
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "currentRevisionV2",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QuestionResponse",
                    "kind": "LinkedField",
                    "name": "response",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a9484ead7d01f03a471fe4f865fe278",
    "id": null,
    "metadata": {},
    "name": "surveysQuery",
    "operationKind": "query",
    "text": "query surveysQuery(\n  $surveyEntityId: String!\n) {\n  viewer {\n    findSurvey(surveyId: $surveyEntityId) {\n      id\n      entityId\n      name\n      details\n      questions {\n        surveyQuestion {\n          id\n        }\n        id\n        question {\n          __typename\n          body\n          hasComment\n          currentRevision: currentRevisionV2 {\n            __typename\n            id\n          }\n          ... on EngagementMultipleChoiceQuestion {\n            questionOptionSet {\n              options {\n                id\n                entityId\n                body\n              }\n            }\n          }\n          id\n        }\n        response {\n          response\n          multipleChoiceResponse {\n            id\n            entityId\n            body\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e7ec2d75e4089e66990dbd0d76c16d2";

export default node;
